const style = {
  root: {
    background: "#0C091B",
    width: "100%",
    fontFamily: "'Inter', sans-serif",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
    color: "white",
    maxWidth: "100%",
    paddingBottom: "95px",
    "& h1": {
      margin: "0",
    },
    "@media(min-width:1920px)": {
      minHeight: "100vh",
    },
    "@media(min-width:1368px)": {
      minHeight: "75vh",
    },
    "@media(max-width:1600px)": {
      minHeight: "71vh",
    },
    "@media(max-width:480px)": {
      minHeight: "81vh",
    },
  },
  tab: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: "400",
    textTransform: "capitalize",
    "&:focus": {
      outline: "none",
    },
    "@media (max-width: 480px)": {
      maxWidth: "100%",
      fontSize: "14px",
    },
  },
  tabList: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "60px 0",
  },

  tabPanel: {
    display: "block",
    position: "relative",
    padding: "40px 0",
  },
  tabContainer: {
    display: "flex",
    position: "relative",
    maxWidth: "395px",
    marginBottom: "20px !important",
    "& .Mui-selected": {
      color: "#e14084 !important",
      backgroundColor: "#fff",
    },
    "& .MuiTabs-flexContainer": {
      width: "100%",
      borderBottom: "1px solid #242033",
    },
  },
  tabContentBoxPortfolio: {
    display: "block",
    position: "relative",
    padding: "0 15px 60px 15px",
    width: "1157px",
    margin: "auto",
    "& > img": {
      width: "100%",
      maxWidth: "271px",
      height: "271px",
      objectFit: "contain",
      marginBottom: "35px",
      padding: "60px",
      borderRadius: "10px",
      border: "7px solid rgba(255, 255, 255, 0.03)",
      background: "rgba(196, 196, 196, 0.077)",
    },
    "@media(max-width:480px)": {
      padding: "0",
      width: "100%",
      margin: "unset",
    },
  },
  stats: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    marginBottom: "32px",
    "& li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      maxWidth: "300px",
      borderRadius: "8px",
      padding: "1px",
      background: "linear-gradient(#E14084,#3454FA,#54B5BB)",
      marginRight: "30px",
    },
    "& li > div": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      background: "#2E2843",
      padding: "20px 20px",
      borderRadius: "8px",
      "& small": {
        color: "#fff",
        fontSize: "14px",
        fontWeight: "400",
        width: "100%",
      },
      "& p": {
        color: "#fff",
        fontSize: "20px",
        fontWeight: "400",
        width: "100%",
      },
      "& img": {
        marginRight: "16px",
      },
      "& span": {
        color: "#fff",
        fontSize: "16px",
        fontWeight: "400",
        marginLeft: "10px",
      },
      "& span:before": {
        content: "''",
        position: "relative",
        display: "inline-block",
        width: "1px",
        left: "-3px",
      },
      "& span.up": {
        color: "#54B5BB",
      },
      "& span.up:before": {
        borderBottom: "9px solid #54B5BB",
        borderLeft: "6px solid transparent",
        borderRight: "6px solid transparent",
        borderTop: "6px solid transparent",
      },
      "& span.down": {
        color: "red",
      },
      "& span.down:before": {
        borderBottom: "6px solid transparent",
        borderLeft: "6px solid transparent",
        borderRight: "6px solid transparent",
        borderTop: "9px solid red",
      },
    },
    "& li div div": {
      position: "relative",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      alignContent: "center",
    },
    "@media(max-width:480px)": {
      display: "block",
      width: "100%",
      "& li": {
        margin: "0 0 15px",
        width: "100%",
        maxWidth: "initial",
      },
      "& li div div": {
        flexWrap: "initial",
        width: "100%",
      },
      "& img": {
        display: "none",
      },
      "& li > div": {
        padding: "12px 15px",
        "& p": {
          whiteSpace: "nowrap",
        },
      },
    },
  },
  Trade__Activity: {
    table: {
      "& tr": {
        borderRadius: "5px",

        "& td": {
          fontSize: "14px",
          padding: "15px",
          width: "27%",

          "& p": {
            fontSize: "14px",
            "@media (max-width: 480px)": {
              fontSize: "12px",
              whiteSpace: "nowrap",
              width: "60px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            "& img": {
              "@media (max-width: 480px)": {
                marginRight: "4px",
              },
            },
          },
          "@media (max-width: 480px)": {
            width: "auto",
            fontSize: "12px",
          },
        },
      },
      "& tr:nth-child(even)": {
        backgroundColor: "#242033",
      },
    },
  },
  headingTitle: {
    "& h1": {
      fontWeight: "700",
      fontSize: "42px",
      "@media(max-width:480px)": {
        fontSize: "18px",
        fontWeight: "500",
        padding: "10px",
      },
    },
  },
  sellBtn: {
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 24px",
    color: "#fff",
    width: "74px",
    height: "32px",
    borderRadius: "8px",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: " 14px",
    lineHeight: "17px",
    background: "transparent",
    border: "1px solid #FFFFFF",
    "@media(max-width:480px)": {
      width: "100%",
      height: "40px",
      // marginLeft: "30px",
    },
  },
  buyBtn: {
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 24px",
    width: "74px",
    height: "32px",
    color: "#fff",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: " 14px",
    lineHeight: "17px",
    marginRight: "16px",
    background:
      "linear-gradient(90.52deg, #E14084 4.01%, #3454FA 57.04%, #54B5BB 103.77%)",
    borderRadius: "8px",
    "@media(max-width:480px)": {
      width: "100%",
      height: "40px",
    },
  },
  accordion: {
    background: "transparent",
    width: "100%",
    boxShadow: "none",
    borderBottom: "1px solid rgb(255 255 255 / 20%)",
    borderRadius: "0 !important",
    margin: "0 !important",
  },

  accordionDetails: {
    position: "relative",
    display: "block",
    width: "100%",
    borderRadius: "0",
    overflow: "hidden",
    color: "#fff",
    padding: "15px 0",
    fontSize: "18px",
    fontWeight: "500",
    "@media(max-width:480px)": {
      padding: "0",
    },
    "& tbody td": {
      padding: "8px 7px",
      fontSize: "14px",
      color: "#fff",
      borderBottom: "none",
    },
  },
  accordionSummary: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    borderRadius: "0 !important",
    overflow: "hidden",
    color: "#fff",
    padding: "0",
    fontSize: "18px",
    fontWeight: "500",
    margin: "0",

    "& > div": {
      margin: "0 !important",
    },
    "& svg": {
      fill: "#fff",
    },
    "& tbody td": {
      padding: "11px 7px",
      textAlign: "center",
      fontSize: "14px",
      color: "#fff",
      // minHeight:"94px",
      borderBottom: "none",
    },
    "& tbody td span": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "400",
      marginLeft: "10px",
    },
    "& tbody td span:before": {
      content: "''",
      position: "relative",
      display: "inline-block",
      width: "1px",
      left: "-3px",
    },
    "& tbody td span.up": {
      color: "#54B5BB",
    },
    "& tbody td span.up:before": {
      borderBottom: "9px solid #54B5BB",
      borderLeft: "6px solid transparent",
      borderRight: "6px solid transparent",
      borderTop: "6px solid transparent",
    },
    "& tbody td span.down": {
      color: "red",
    },
    "& tbody td span.down:before": {
      borderBottom: "6px solid transparent",
      borderLeft: "6px solid transparent",
      borderRight: "6px solid transparent",
      borderTop: "9px solid red",
    },
    "@media(max-width:480px)": {
      "& tbody td img": {
        width: "40px !important",
        height: "40px !important",
      },
      "& tbody td p": {
        fontSize: "12px",
      },
      "& table": {
        tableLayout: "auto !important",
      },
    },
  },
};
export default style;
